import { render } from "./Stars.vue?vue&type=template&id=61946e78"
import script from "./Stars.vue?vue&type=script&lang=js"
export * from "./Stars.vue?vue&type=script&lang=js"

import "./Stars.vue?vue&type=style&index=0&id=61946e78&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__